<template>
  <div class="mb-4">
    <div class="flex justify-between items-center mb-2">
      <span :qaid="`summary-list__${name}-title`" class="font-heading text-lg text-gray-100" v-html="bp(name)" />

      <trek-button
        v-if="isVisible"
        :qaid="`summary-list__${name}-change-selection-btn`"
        button
        icon-right
        icon="arrow_forward"
        text
        small
        @click="$router.push({name})"
      >
        <span v-html="bp('changeSelections')" />
      </trek-button>
    </div>

    <div>
      <template v-for="item in groups">
        <project-one-summary-choice
          v-if="Array.isArray(item.choices) && item.choices.length"
          :id="item.id"
          :key="item.id"
          :description="item.description"
          :choice="item.choices[0]"
          :has-image="hasImages"
          :presentation-type="item.presentationType"
        />
        <project-one-personalize-font-preview
          v-if="personalizationText && item.id === 36"
          :key="`${item.id}-font-preview`"
          class="my-1"
          :base-properties="baseProperties"
          :personalization-text="personalizationText"
          :has-helper-text="false"
          :font-choice-id="fontChoiceId"
        />
      </template>
    </div>
  </div>
</template>

<script>
import TrekButton from '@/components/TrekButton.vue';
import ProjectOneSummaryChoice from '@/projectOne/components/summary/components/ProjectOneSummaryChoice';
import ProjectOnePersonalizeFontPreview from '@/projectOne/components/shared/ProjectOnePersonalizeFontPreview';
import {mapState} from 'vuex';

export default {
  components: {TrekButton, ProjectOneSummaryChoice, ProjectOnePersonalizeFontPreview},

  props: {
    name: {
      type: String,
      default: '',
    },
    groups: {
      type: Array,
      default: () => [],
    },
    hasImages: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState('projectOne', ['bikeData']),
    ...mapState('backend', ['b2b']),

    // Only hide change selection link if user is B2C(logged in or logged out) and P1Configuration has a status of “Sent to Dealer”
    // Hardcoded for sizing, 'Change selections' NOT to be shown on Sizing Section only.
    isVisible() {
      return !(!this.b2b && this.bikeData.p1ConfigStatus === 'Sent') && this.name !== 'sizing';
    },
    personalizationText() {
      let personalizationText = null;
      this.groups.forEach((group) => {
        if (group.id === 35 && group.personalizationText?.length) {
          personalizationText = group.personalizationText;
        }
      });
      return personalizationText;
    },
    fontChoiceId() {
      let fontChoiceId = null;
      this.groups.forEach((group) => {
        if (group.id === 36) {
          fontChoiceId = group.choices[0].id;
        }
      });
      return fontChoiceId;
    },
  },
};
</script>
